import { createContext } from 'react';
import { IApplicationState } from './state/IApplicationState';

export const ApplicationContext = createContext<IApplicationState>({} as IApplicationState);
